export const SETUP_2FA_REQUEST = 'SETUP_2FA_REQUEST';
export const ENABLE_2FA_REQUEST = 'ENABLE_2FA_REQUEST';
export const DISABLE_2FA_REQUEST = 'DISABLE_2FA_REQUEST';
export const REGENERATE_BACKUP_CODES_REQUEST = 'REGENERATE_BACKUP_CODES_REQUEST';
export const VERIFY_2FA_REQUEST = 'VERIFY_2FA_REQUEST';
export const GET_TRUSTED_DEVICES_REQUEST = 'GET_TRUSTED_DEVICES_REQUEST';
export const REVOKE_TRUSTED_DEVICE_REQUEST = 'REVOKE_TRUSTED_DEVICE_REQUEST';
export const REVOKE_ALL_TRUSTED_DEVICES_REQUEST = 'REVOKE_ALL_TRUSTED_DEVICES_REQUEST';

export const setup2FA = (callback) => ({
    type: SETUP_2FA_REQUEST,
    payload: { callback },
});

export const enable2FA = (password, code, callback) => ({
    type: ENABLE_2FA_REQUEST,
    payload: { password, code, callback },
});

export const disable2FA = (password, code, callback) => ({
    type: DISABLE_2FA_REQUEST,
    payload: { password, code, callback },
});

export const regenerateBackupCodes = (password, code, callback) => ({
    type: REGENERATE_BACKUP_CODES_REQUEST,
    payload: { password, code, callback },
});

export const verify2FA = ({ mfaToken, code, rememberDevice, callback } = {}) => ({
    type: VERIFY_2FA_REQUEST,
    payload: { mfaToken, code, rememberDevice, callback },
});

export const getTrustedDevices = (callback) => ({
    type: GET_TRUSTED_DEVICES_REQUEST,
    payload: { callback },
});

export const revokeTrustedDevice = ({ id, callback } = {}) => ({
    type: REVOKE_TRUSTED_DEVICE_REQUEST,
    payload: { id, callback },
});

export const revokeAllTrustedDevices = (callback) => ({
    type: REVOKE_ALL_TRUSTED_DEVICES_REQUEST,
    payload: { callback },
});
